import { AUTH_CLAIMS } from '@/config/auth.config'
import type { AuthUser } from '@/auth/auth-provider'
import {
  isStaff as isStaffRoleValue,
  isSuperRole,
  ParsedRole,
  ROLE,
  parseRole,
} from '@/auth/roles'

export interface PrincipalClaims {
  role: ParsedRole
}

export function parsePrincipalFromUser(user: AuthUser | undefined): PrincipalClaims {
  if (!user) {
    return { role: ROLE.NONE }
  }
  const u = user as Record<string, unknown>
  return { role: parseRole(u[AUTH_CLAIMS.ROLE]) }
}

/** Same logic as `AccessService.isSuper`. */
export function isSuper(p: PrincipalClaims): boolean {
  return isSuperRole(p.role)
}

export function isStaffRole(p: PrincipalClaims): boolean {
  return isStaffRoleValue(p.role)
}

/**
 * Same logic as `AccessService.canSeeData`: super admins and staff see every dealership's dashboards,
 * appointments, conversations and configuration. What else each may do is still decided by role.
 */
export function canSeeData(p: PrincipalClaims): boolean {
  return isSuper(p) || isStaffRole(p)
}

/** Default route after login / app index: everyone lands on the group dashboard first. */
export function defaultPostLoginPath(): string {
  return '/group/dashboard'
}
